import { zodResolver } from "@hookform/resolvers/zod";
import _ from "lodash";
import { usePostHog } from "posthog-js/react";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "./ui/button";
import { AlcDrawer, DrawerTitle } from "./ui/drawer";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from "./ui/form";
import { Textarea } from "./ui/textarea";

const FormSchema = z.object({
  text: z.string().min(1).max(1000000),
});

const ReportBugDrawer = ({ children }: { children: any }) => {
  const [isOpen, setIsOpen] = useState(false);
  const sentShown = useRef(false);

  const [sent, setSent] = useState(false);

  const form = useForm<z.infer<typeof FormSchema>>({
    mode: "onBlur",
    resolver: zodResolver(FormSchema),
    defaultValues: {
      text: "",
    },
  });

  const postHog = usePostHog();

  useEffect(() => {
    if (isOpen) {
      if (sentShown.current) return;
      sentShown.current = true;
      postHog.capture("survey shown", {
        $survey_id: process.env.REACT_APP_POSTHOG_SURVEY_ID,
      });
    } else {
      if (sentShown.current)
        postHog.capture("survey dismissed", {
          $survey_id: process.env.REACT_APP_POSTHOG_SURVEY_ID,
        });
      sentShown.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  async function onSubmit(data: z.infer<typeof FormSchema>) {
    data = _.omitBy(data, (v) => v === null || v === "");
    postHog.capture("survey sent", {
      $survey_id: process.env.REACT_APP_POSTHOG_SURVEY_ID,
      $survey_response: data.text,
    });

    setSent(true);
    form.reset();
    sentShown.current = false;
  }

  return (
    <AlcDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      trigger={children}
      asChild
      header={
        <>
          <DrawerTitle className="text-center">Nahlášení problému</DrawerTitle>
        </>
      }
    >
      {sent && (
        <div className="p-4 bg-green-100 text-green-800 rounded-lg mb-4">
          Díky moc za zanechání této zpětné vazby. Moc si toho vážíme ❤❤❤
        </div>
      )}
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          <FormField
            control={form.control}
            name="text"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Popiš, prosím, svůj problém.</FormLabel>
                <FormControl>
                  <Textarea
                    id="text"
                    maxLength={1000000}
                    className="resize-none"
                    {...field}
                  />
                </FormControl>
                <FormDescription>
                  Každá zpětná zpětná vazba je velmi ceněná. Děkujeme!
                </FormDescription>
              </FormItem>
            )}
          />
          <div className="py-4">
            <Button type="submit" className="w-full">
              {"Odeslat"}
            </Button>
          </div>
        </form>
      </Form>
    </AlcDrawer>
  );
};

export default ReportBugDrawer;
